var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect, useRef, useState } from 'react';
import { Form } from 'react-final-form';
import { Button, DropdownClose, DropdownDownArrow, GBTypography, TextInput } from '@leapfinance/geebee-component-library';
import { Divider, IconButton, Popover } from '@mui/material';
import classNames from 'classnames';
import useFinalFormYupFormHelpers from '../../../../helpers/finalform/useFinalFormYupFormHelpers';
import { isFalsy } from '../../../../utils/common';
import { fieldToLabelMapping } from '../utils';
import { eligibilitySchema, eligiblityAcademicSchema } from './schema/eligibility.schema';
import BachelorsExamCFFilter from './BachelorsExamCFFilter';
export var gradeOptions = [
    {
        label: 'CGPA',
        value: 'CGPA'
    },
    {
        label: 'Percentage',
        value: 'PERCENTAGE'
    },
    {
        label: '0 to 4',
        value: 'ZERO_TO_FOUR'
    }
];
var AcademicCFFilter = function (props) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    var _j = __read(useFinalFormYupFormHelpers({
        schema: eligiblityAcademicSchema
    }), 2), validate = _j[0], formNames = _j[1];
    var _k = __read(React.useState(null), 2), anchorEl = _k[0], setAnchorEl = _k[1];
    var _l = __read(useState(), 2), errorMessage = _l[0], setErrorMessage = _l[1];
    var open = Boolean(anchorEl);
    var id = open ? 'university-academic-filter-popover' : undefined;
    var inputRef = useRef(null);
    var formRef = useRef();
    useEffect(function () {
        if (open)
            return;
        eligibilitySchema === null || eligibilitySchema === void 0 ? void 0 : eligibilitySchema.validate(props === null || props === void 0 ? void 0 : props.initialValues, { abortEarly: false }).then(function () {
            setErrorMessage('');
        }).catch(function (err) {
            var errorFields = [];
            err.inner.forEach(function (e) {
                var _a, _b, _c, _d;
                if ((_a = e.path) === null || _a === void 0 ? void 0 : _a.includes('ug')) {
                    errorFields.push("Bachelors: ".concat((_b = fieldToLabelMapping === null || fieldToLabelMapping === void 0 ? void 0 : fieldToLabelMapping[e.path]) !== null && _b !== void 0 ? _b : e.path));
                }
                if ((_c = e.path) === null || _c === void 0 ? void 0 : _c.includes('twelfth')) {
                    errorFields.push("Twelfth: ".concat((_d = fieldToLabelMapping === null || fieldToLabelMapping === void 0 ? void 0 : fieldToLabelMapping[e.path]) !== null && _d !== void 0 ? _d : e.path));
                }
            });
            if (isFalsy(errorFields))
                return;
            var message = errorFields.map(function (field) { return field === null || field === void 0 ? void 0 : field.toLocaleUpperCase(); }).join(', ');
            setErrorMessage("Invalid ".concat(message));
        });
    }, [props === null || props === void 0 ? void 0 : props.initialValues, open]);
    useEffect(function () {
        if (open && !!errorMessage) {
            setErrorMessage('');
            // submit the form so the errors are visible on opening
            setTimeout(function () {
                var _a;
                void ((_a = formRef === null || formRef === void 0 ? void 0 : formRef.current) === null || _a === void 0 ? void 0 : _a.submit());
            }, 0);
        }
    }, [open]);
    var handleClose = function () {
        setAnchorEl(null);
        setTimeout(function () {
            var _a;
            (_a = inputRef === null || inputRef === void 0 ? void 0 : inputRef.current) === null || _a === void 0 ? void 0 : _a.blur();
        }, 0);
    };
    var handleFormSubmit = function (values) {
        var _a;
        var newValues = __assign(__assign({}, values), { ugGradingScheme: isFalsy(values === null || values === void 0 ? void 0 : values.ugBacklogs) && isFalsy(values === null || values === void 0 ? void 0 : values.ugGrade) ? null : values === null || values === void 0 ? void 0 : values.ugGradingScheme, twelfthGradingScheme: isFalsy(values === null || values === void 0 ? void 0 : values.twelfthGrade) ? null : values === null || values === void 0 ? void 0 : values.twelfthGradingScheme });
        (_a = props === null || props === void 0 ? void 0 : props.onApply) === null || _a === void 0 ? void 0 : _a.call(props, newValues);
        handleClose();
    };
    var clearFilters = function () {
        handleFormSubmit({
            ugBacklogs: null,
            ugGrade: null,
            ugGradingScheme: null,
            twelfthGrade: null,
            twelfthGradingScheme: null,
            universityNaac: null
        });
    };
    var bachelorValues = [
        (_b = (_a = props === null || props === void 0 ? void 0 : props.initialValues) === null || _a === void 0 ? void 0 : _a.ugGradingScheme) === null || _b === void 0 ? void 0 : _b.label,
        (_c = props === null || props === void 0 ? void 0 : props.initialValues) === null || _c === void 0 ? void 0 : _c.ugGrade,
        (_d = props === null || props === void 0 ? void 0 : props.initialValues) === null || _d === void 0 ? void 0 : _d.ugBacklogs,
        (_e = props === null || props === void 0 ? void 0 : props.initialValues) === null || _e === void 0 ? void 0 : _e.universityNaac
    ];
    var twelfthValues = [(_g = (_f = props === null || props === void 0 ? void 0 : props.initialValues) === null || _f === void 0 ? void 0 : _f.twelfthGradingScheme) === null || _g === void 0 ? void 0 : _g.label, (_h = props === null || props === void 0 ? void 0 : props.initialValues) === null || _h === void 0 ? void 0 : _h.twelfthGrade];
    var bachelorsExamLabel = (bachelorValues === null || bachelorValues === void 0 ? void 0 : bachelorValues.every(isFalsy)) ? '' : "Bachelor's";
    var twelfthExamLabel = (twelfthValues === null || twelfthValues === void 0 ? void 0 : twelfthValues.some(isFalsy)) ? '' : '12th/Diploma';
    var displayValue = [bachelorsExamLabel, twelfthExamLabel].filter(function (o) { return !isFalsy(o); }).join(', ');
    return (React.createElement("div", { onClick: function (event) {
            if (!anchorEl) {
                setAnchorEl(event.currentTarget);
            }
        }, "data-hasValue": !isFalsy(displayValue) },
        React.createElement(TextInput, { label: "Academic Background", keepDefaultLabelBehaviour: true, className: classNames('lfc-w-[190px]  lfc-transition-all '), InputLabelProps: { shrink: open || !!displayValue }, helperText: errorMessage, error: !!errorMessage, value: displayValue, size: "small", InputProps: {
                readOnly: true,
                endAdornment: (React.createElement(React.Fragment, null,
                    displayValue ? (React.createElement(IconButton, { onClick: function (event) {
                            event.stopPropagation();
                            clearFilters();
                        } },
                        React.createElement(DropdownClose, { size: "small" }))) : null,
                    React.createElement(DropdownDownArrow, { size: "small", classNames: classNames('', { 'lfc-rotate-180': open }) }))),
                sx: function (theme) {
                    var _a, _b, _c, _d, _e;
                    return displayValue && !open
                        ? {
                            '&.MuiOutlinedInput-root': {
                                backgroundColor: (_a = theme.palette.primary) === null || _a === void 0 ? void 0 : _a['200'],
                                fieldSet: {
                                    borderColor: (_b = theme.palette.primary) === null || _b === void 0 ? void 0 : _b['500']
                                },
                                ':hover': {
                                    backgroundColor: (_c = theme.palette.primary) === null || _c === void 0 ? void 0 : _c['200']
                                    // fieldSet: {
                                    //   borderColor: theme.palette.primary?.['500']
                                    // }
                                },
                                '.MuiInputAdornment-positionStart': {
                                    '.MuiTypography-root': {
                                        color: (_d = theme.palette.primary) === null || _d === void 0 ? void 0 : _d['500']
                                    }
                                },
                                input: {
                                    textOverflow: 'ellipsis',
                                    color: (_e = theme.palette.primary) === null || _e === void 0 ? void 0 : _e['500']
                                }
                            }
                        }
                        : {
                            '&.MuiOutlinedInput-root': {
                                backgroundColor: 'white'
                            }
                        };
                }
            }, type: "search", onClick: function (event) {
                if (!anchorEl) {
                    setAnchorEl(event.currentTarget);
                }
            }, inputRef: inputRef }),
        React.createElement(Popover, { id: id, open: open, anchorEl: anchorEl, onClose: handleClose, anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'left'
            }, transformOrigin: { vertical: 0, horizontal: 0 }, slotProps: { paper: { sx: { overflow: 'visible' }, elevation: 0 } }, className: "lfc-mt-1 " },
            React.createElement(Form, { validate: validate, initialValues: props === null || props === void 0 ? void 0 : props.initialValues, onSubmit: handleFormSubmit, render: function (_a) {
                    var handleSubmit = _a.handleSubmit, form = _a.form;
                    formRef.current = form;
                    return (React.createElement("div", { className: "  lfc-pt-4 lfc-max-h-[650px] lfc-overflow-y-auto lfc-flex lfc-flex-col lfc-gap-6 lfc-rounded-md lfc-border lfc-shadow-lg  lfc-w-[350px]   [&>.education-container]:lfc-flex [&>.education-container]:lfc-flex-col [&>.education-container]:lfc-gap-3" },
                        React.createElement("div", { className: "lfc-px-4" },
                            React.createElement("div", { className: "lfc-flex lfc-gap-2 lfc-items-center lfc-bg-gbTokens-sapphire-200 lfc-py-1 lfc-px-2 lfc-rounded-md" },
                                React.createElement("div", null,
                                    React.createElement("i", { className: "fi fi-rr-square-info" })),
                                React.createElement(GBTypography, { variant: "caption1" }, "Enter the academic scores of the student to filter courses based on eligibility."))),
                        React.createElement("div", { className: "education-container lfc-px-4" },
                            React.createElement(GBTypography, { variant: "sh2" }, "Bachelor's Degree"),
                            React.createElement(BachelorsExamCFFilter, { backlogsFieldName: formNames.ugBacklogs, gradeFieldName: formNames.ugGrade, gradingSchemeFieldName: formNames.ugGradingScheme, renderBacklog: true, title: "Bachelor's Degree", gradeSystemOptions: gradeOptions, naacFieldName: (props === null || props === void 0 ? void 0 : props.renderNaac) ? formNames.universityNaac : '', naacOptions: props === null || props === void 0 ? void 0 : props.naacOptions })),
                        React.createElement(Divider, null),
                        React.createElement("div", { className: "education-container lfc-px-4" },
                            React.createElement(GBTypography, { variant: "sh2" }, "12th/Diploma"),
                            React.createElement(BachelorsExamCFFilter, { gradeFieldName: formNames.twelfthGrade, gradingSchemeFieldName: formNames.twelfthGradingScheme, gradeSystemOptions: gradeOptions, title: "12th/Diploma" })),
                        React.createElement("div", { className: "lfc-flex lfc-flex-col lfx-w-full lfc-justify-end" },
                            React.createElement(Divider, null),
                            React.createElement("div", { className: "lfc-self-end lfc-p-2 lfc-flex lfc-gap-2" },
                                React.createElement(Button, { variant: "tertiary", onClick: function () {
                                        clearFilters();
                                    } }, "Clear"),
                                React.createElement(Button, { onClick: function () { return handleSubmit(); } }, "Apply")))));
                } }))));
};
export default AcademicCFFilter;
//# sourceMappingURL=AcademicCFFilter.js.map